import {
    /** FETCH ADDADDRESS  */
    FETCH_ADDADDRESS_FULFILLED,
    FETCH_ADDADDRESS_REJECTED,
    FETCH_ADDADDRESS_PENDING,
    RESET_ADDADDRESS,
  } from "../../actions/payment/addAddress";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ADDADDRESS_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_ADDADDRESS_FULFILLED:
        return {
          ...state,
          addAddress: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_ADDADDRESS_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_ADDADDRESS:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  